import comp from "./QueryParamsBasedInterfaceHOC";
export default comp;
